import CompanyList from './CompanyList';

export default {
    CompanyList,
};



// WEBPACK FOOTER //
// ./src/components/InstallationCompany/index.js